<div class="container">
  <span class="eyebrow">{{ 'artistes.eyebrow' | traduire }}</span>
  <h2>{{ 'artistes.titre' | traduire }}</h2>

  <div class="artiste-grid">
    <div class="artiste-flip" *ngFor="let artiste of artistes">
      <div class="flip-inner">
        <div class="face front">
          <video *ngIf="estVideo(artiste.photoUrl)" [src]="artiste.photoUrl" muted loop autoplay playsinline></video>
          <img *ngIf="!estVideo(artiste.photoUrl)" [src]="artiste.photoUrl || 'https://images.unsplash.com/photo-1601288496920-b6154fe3626a?w=400'" [alt]="artiste.nom">
          <div class="front-info">
            <div class="nom">{{ artiste.nom }}</div>
            <div class="role">{{ artiste.role }}</div>
          </div>
        </div>
        <div class="face back">
          <div class="nom">{{ artiste.nom }}</div>
          <div class="role">{{ artiste.role }}</div>
          <p class="bio">{{ artiste.bio }}</p>
        </div>
      </div>
    </div>
  </div>
</div>
